<div data-aos="zoom-in" data-aos-once="true">
    <div [className]="'index-container'">

    </div>
</div>